export const getColorByIndex = (index: number) => {
    switch (index) {
        case 0:
            return "#CDE838";
        case 1:
            return "#FF8A00";

        case 2:
            return "#0093E5";

        case 3:
            return "#6161FF";
        default:
            return "black";
    }
};
